import {Breadcrumbs, Link, Stack, Typography} from "@mui/material";
import {Link as RouterLink} from "react-router";
import {appStyles} from "../AppStyles.ts";

interface BreadcrumbLink
{
    display: string;
    linkTo: string;
    activeView: boolean;
}

function WidgetHeader(props: { title: string, breadcrumbs?: BreadcrumbLink[] })
{
    return (
        <Stack direction="row" sx={appStyles.mainContentHeaderBackground} spacing={0} justifyContent="space-between" alignItems="center" width="100%" >
            <Breadcrumbs separator="/" sx={{ color: "#eaeaea"}}>
                {/*<Link component={RouterLink} to={"/networks"} underline={"hover"}>Networks</Link>*/}
                {
                    props.breadcrumbs ? (
                        props.breadcrumbs.map((nextLink:BreadcrumbLink) => (
                            nextLink.activeView ? (<Typography key={nextLink.linkTo} sx={appStyles.primaryLabel}>{nextLink.display}</Typography> ):
                                (<Link sx={appStyles.secondaryLabel} key={nextLink.linkTo} component={RouterLink} to={nextLink.linkTo}>{nextLink.display}</Link>)
                        ))
                    ): (<></>)
                }
            </Breadcrumbs>
            <Stack direction="row" alignItems="center">
                <img src="/images/default_network_image.png" width={32} />
                <Typography sx={appStyles.mainContentTitle} paddingLeft={1} >{props.title}</Typography>
            </Stack>
        </Stack>
    )
}

export default WidgetHeader

